import {styled} from '@mui/material/styles';
import {ListItemButton, useTheme} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useMemo} from 'react';

import {StoredFilter} from 'filters/features/types';

import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';

import CheckIcon from 'components/icons/check.svg';

import {isEqualFilters} from 'modules/decisionsNext/components/BaseFilter/utils/filter';

const SListItemButton = styled(ListItemButton)(({theme}) => ({
  padding: theme.spacing(2.5, 3),
}));

const SCheckIcon = styled(CheckIcon)(() => ({
  marginLeft: 'auto',
}));

export const PresetItem = ({
  preset,
  selected,
  onSelect,
}: {
  preset: StoredFilter;
  selected: boolean;
  onSelect: () => void;
}) => {
  const theme = useTheme();
  const {filter} = useEditedFilterContext();

  const isActive = useMemo(() => isEqualFilters(preset.filter, filter), [filter, preset.filter]);

  return (
    <SListItemButton key={preset.id} selected={selected} onClick={onSelect}>
      <Typography variant='subtitle1'>{preset.name}</Typography>
      {isActive && <SCheckIcon color={theme.palette.primary.main} width={16} height={16} />}
    </SListItemButton>
  );
};
